export default __webpack_public_path__ + "static/media/russiantblewindows2.ce7be19a.webp";